import { Platform } from 'react-native';

/**
 * Whether this platform can actually prompt for / report a notification permission.
 * Always true on native. On web it is false when the browser exposes no Notification API —
 * e.g. a regular Safari tab on iPad, where the status can never resolve past 'undetermined'
 * and calling the prompt is a silent no-op.
 *
 * Evaluated lazily (not at module scope) so a prerendered/SSR pass, where `window` is
 * missing, can't freeze the answer to false for the real browser session.
 */
export function isNotificationSupported(): boolean {
  if (Platform.OS !== 'web') return true;
  return (
    typeof window !== 'undefined' && typeof window.Notification?.requestPermission === 'function'
  );
}
